// Conservative, taste-preserving swaps. Only offered when the substitute is in the kitchen AND
// passes the user's diet rules (ranking.ts re-checks, a swap can never introduce a violation).

import type { IngredientId } from './taxonomy';

export interface Substitution {
  from: IngredientId;
  to: IngredientId;
  note: string;
}

export const SUBSTITUTIONS: Substitution[] = [
  { from: 'heavy_cream', to: 'milk', note: 'Thinner sauce, so simmer a little longer to reduce.' },
  { from: 'heavy_cream', to: 'greek_yogurt', note: 'Tangier; stir in off the heat so it doesn\'t split.' },
  { from: 'sour_cream', to: 'greek_yogurt', note: 'Similar tang and texture.' },
  { from: 'greek_yogurt', to: 'yogurt', note: 'Runnier. Strain it if you can.' },
  { from: 'parmesan', to: 'cheddar', note: 'Sharper and meltier, less salty.' },
  { from: 'mozzarella', to: 'cheddar', note: 'Stronger flavour, similar melt.' },
  { from: 'cheddar', to: 'mozzarella', note: 'Milder, stretchier.' },
  { from: 'feta', to: 'cheddar', note: 'Less salty and briny; melts more.' },
  { from: 'fresh_basil', to: 'oregano', note: 'Use a pinch of dried; earthier.' },
  { from: 'spinach', to: 'kale', note: 'Sturdier, so cook a minute or two longer.' },
  { from: 'scallions', to: 'onion', note: 'Use half the amount; sharper.' },
  { from: 'red_onion', to: 'onion', note: 'Slightly sharper.' },
  { from: 'lemon', to: 'lime', note: 'Similar acidity.' },
  { from: 'lime', to: 'lemon', note: 'Similar acidity.' },
  { from: 'cornstarch', to: 'flour', note: 'Use twice as much; a cloudier finish.' },
  { from: 'flour_tortillas', to: 'corn_tortillas', note: 'Smaller and more fragile, so warm them well.' },
  { from: 'corn_tortillas', to: 'flour_tortillas', note: 'Softer and larger.' },
  { from: 'honey', to: 'sugar', note: 'Use ¾ the amount plus a splash of water.' },
  { from: 'brown_sugar', to: 'sugar', note: 'Slightly less rich.' },
  { from: 'tomato_sauce', to: 'tomato_paste', note: '2 tbsp paste + ½ cup water per cup of sauce.' },
  { from: 'tomatoes', to: 'cherry_tomatoes', note: 'Sweeter. Halve them.' },
  { from: 'bell_pepper', to: 'zucchini', note: 'Different flavour, similar bulk.' },
  { from: 'chicken_breast', to: 'chicken_thighs', note: 'Juicier; cook a couple of minutes longer to 165°F (74°C).' },
  { from: 'white_rice', to: 'brown_rice', note: 'Nuttier; needs about 25 minutes longer to cook.' },
  { from: 'olive_oil', to: 'cooking_oil', note: 'Neutral flavour.' },
  { from: 'cooking_oil', to: 'olive_oil', note: 'Fine for medium heat.' },
  { from: 'butter', to: 'olive_oil', note: 'Use a little less; no browned-butter flavour.' },
  { from: 'vinegar', to: 'lemon', note: 'Brighter, fruitier acidity.' },
];

export function substitutesFor(id: IngredientId): Substitution[] {
  return SUBSTITUTIONS.filter((s) => s.from === id);
}
